import {DatePipe} from "@angular/common";
import {Pipe, PipeTransform} from "@angular/core";

@Pipe({
    name: 'orderDate'
})
export class OrderDatePipe extends DatePipe implements PipeTransform {
    transform(value: string, pattern?: string): string {
        if (!value)
        {
            return '' ; 
        }
        let date = '';
        if (value.indexOf('0001-01-01') !== -1  || value.indexOf('1753-01-01T00:00:00') !== -1 || value === '')  {
            return '';
        } else {
            value = value.replace(" undefined" , '') ;
            return super.transform(new Date(value), 'dd/MM/yyyy');
        }
    }
}
